import { expandDepartureGroup } from "../../configurazione/adapters";
import { useLogisticaConfiguration } from "../../configurazione/LogisticaConfigurationProvider";
import React, { useState, useEffect, useRef } from "react";
import stilePulsanti from "../../../interfaccia/stilePulsanti";
import { useAuth0 } from "@auth0/auth0-react";
import CampoRicercaAvanzata from "./CampoRicercaAvanzata";
//import statoVoceCliccabile from '../statoVoceCliccabile';

function aggiungiParametriVista(input, vista) {
  if (vista !== "note") {
    return input;
  }
  return { ...input, includeNote: "1" };
}

function RicercaAvanzataPochiCampi({
  setUrlRicerca,
  setUrlParametri,
  page,
  perPage,
  setTotalRows,
  setListaOrdini,
  datiTendineOrdine,
  vista,
  campiRicerca,
  inputIniziale,
  urlRicerca,
  setRicerca,
  columnSort,
  directionSort,
  inputVuoto,
  fetchOrdini,
  columnControl,
}) {
  const { groups } = useLogisticaConfiguration();

  const { user, /* isAuthenticated, */ getAccessTokenSilently } = useAuth0();
  const [token, setToken] = useState("");

  const [input, setInput] = useState(inputIniziale);
  const [campi, setCampi] = useState(campiRicerca);
  const fallbackRequestRef = useRef(null);

  const {
    buttonClassesWhite,
    inputClasses,
    inputClassesNoMeasure,
    inputClassesRicercaOrizzontale,
    tastoRicercaOrizzontale,
    inputClassesConTreTasti,
    tastoCercaAspetto,
    tastoChiudiAspetto,
  } = stilePulsanti;

  //const [listastato, setListastato] = useState([]);

  useEffect(() => {
    setCampi(campiRicerca);
    console.log("cambio vista anche in componente selezione " + vista);
  }, [campiRicerca, vista]);

  useEffect(() => {
    const getUserMetadata = async () => {
      try {
        const accessToken = await getAccessTokenSilently();
        setToken(accessToken);
      } catch (e) {
        console.log(e.message);
      }
    };

    getUserMetadata();
  }, [getAccessTokenSilently, user?.sub]);

  useEffect(
    () => () => {
      fallbackRequestRef.current?.abort();
      fallbackRequestRef.current = null;
    },
    []
  );

  const handleChange = async function (evt) {
    const value = evt.target.value;
    try {
      setInput({
        ...input,
        [evt.target.name]: value,
      });
    } catch (err) {
      console.log("Errore nell'aggiornamento di un dato non nestato: " + err);
      throw err;
    }
  };

  const cancellaFiltri = function () {
    setInput(inputVuoto);
  };

  const fetchOrdiniFallback = async (ricerca, accessToken) => {
    fallbackRequestRef.current?.abort();
    const controller = new AbortController();
    fallbackRequestRef.current = controller;
    const urlFinale =
      urlRicerca + 1 + "/" + perPage + "?" + new URLSearchParams(ricerca);

    try {
      const response = await fetch(urlFinale, {
        headers: { Authorization: "Bearer " + accessToken },
        signal: controller.signal,
      });
      if (!response.ok) {
        throw new Error(`Ricerca ordini fallita (${response.status})`);
      }
      const result = await response.json();
      if (
        controller.signal.aborted ||
        fallbackRequestRef.current !== controller
      ) {
        return false;
      }
      setTotalRows(result.total);
      setListaOrdini(result.data);
      return true;
    } catch (error) {
      if (error.name !== "AbortError") {
        console.error("Errore nella ricerca ordini", error);
      }
      return false;
    } finally {
      if (fallbackRequestRef.current === controller) {
        fallbackRequestRef.current = null;
      }
    }
  };

  async function ricercaOrdini(e) {
    e?.preventDefault();
    setUrlRicerca(urlRicerca);
    const inputConVista = aggiungiParametriVista(input, vista);
    const ricercaNormalizzata = expandDepartureGroup(inputConVista, groups);
    setRicerca(ricercaNormalizzata);
    let accessToken = token;
    try {
      accessToken = await getAccessTokenSilently();
      setToken(accessToken);
    } catch (error) {
      if (!accessToken) {
        console.error("Impossibile ottenere il token per la ricerca ordini", error);
        return false;
      }
    }

    if (fetchOrdini) {
      return fetchOrdini(1, urlRicerca, {
        ricerca: ricercaNormalizzata,
        headers: { Authorization: "Bearer " + accessToken },
      });
    }

    return fetchOrdiniFallback(ricercaNormalizzata, accessToken);
  }

  const handleKeyDown = async function (e) {
    if (e.key === "Enter") {
      e.preventDefault();
      ricercaOrdini();
    }
  };

  return (
    <div>
      <div className="gruppoInputRicercaOrizzontale">
        {campi.map((campo) => {
          return (
            <CampoRicercaAvanzata
              key={campo.nome}
              nomeCampo={campo.nome}
              labelCampo={campo.labelCorta || campo.label}
              value={input[campo.nome]}
              tipo={campo.tipo}
              handleChange={handleChange}
              handleKeyDown={handleKeyDown}
              dati={campo.dati}
              divClass={"gruppoInputRicercaOrizzontale mr2"}
              placeholder={campo.placeholder}
              inputStyle={campo.inputStyle}
            />
          );
        })}
        {
          /* vista !== "checkSparati" &&  */ <div className="flex items-center">
            <button
              className="dim tastoInputOrizzontale br3"
              type="button"
              title="Ricerca rapida"
              aria-label="Ricerca rapida"
              onClick={ricercaOrdini}
            >
              {tastoCercaAspetto}
            </button>
          </div>
        }
        {
          /* vista !== "checkSparati" &&  */ <div className="dim pointer h-100 flex items-center br3">
            <button
              className="ml2 tastoInputOrizzontale br3"
              type="button"
              title="Cancella filtri"
              aria-label="Cancella filtri"
              onClick={cancellaFiltri}
            >
              {tastoChiudiAspetto}
            </button>
          </div>
        }
        {columnControl}
      </div>
    </div>
  );
}

export default RicercaAvanzataPochiCampi;
